module.exports = __webpack_public_path__ + "img/cloud-lightning-moon.08102550.svg";